// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__d2WBu","choiceBoxes":"toolbarselects_choiceBoxes__pI7bU","simpleField":"toolbarselects_simpleField__2cIzg"};